/* unplugin-vue-components disabled */import { render } from "./VerticalSwiper.vue?vue&type=template&id=2f391536&scoped=true"
import script from "./VerticalSwiper.vue?vue&type=script&lang=js"
export * from "./VerticalSwiper.vue?vue&type=script&lang=js"

import "./VerticalSwiper.vue?vue&type=style&index=0&id=2f391536&lang=less&scoped=true"

import exportComponent from "/Users/hongboyuan/projects/yszn-code/qipaoWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f391536"]])

export default __exports__